<template>
  <v-dialog
    v-model="mydialog"
    persistent
    max-width="290"
  >
    <v-card>
      <v-card-title class="text-h5">
        {{ count }} 秒后跳转到任务队列
      </v-card-title>
      <v-card-text>Jump to Task List in {{ second }} seconds. 根据上传的文件大小可能需要等待几秒, 甚至几分钟.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          text
          @click="stopJump();mydialog = false"
        >
          稍后
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="jumpNow();mydialog = false"
        >
          立即跳转
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import router from '@/router';
  export default {
    data() {
      return {
        mydialog: false,
        jumpTimeoutId: 0,
        second: 2,
        jumpIntervalId: 0,
        count: 2,
      };
    },
    model: {
      prop: 'dialog',
      event: 'update:dialog',
    },
    props: {
      dialog: {
        type: Boolean,
        required: true,
      },
      to: String,
    },
    watch: {
      dialog(newV) {
        if (newV) {
          this.mydialog = true;
          this.count = this.second;
          this.jumpIntervalId = setInterval( () => {
            this.count -= 1;
          }, 1000);
          this.jumpTimeoutId = setTimeout( () => {
            this.jump();
          }, 1000 * this.second);
        }
      },
      mydialog(newV) {
        if (newV === false) {
          this.$emit('update:dialog', false);
        }
      },
    },
    methods: {
      jump() {
        router.push(this.to);
      },
      jumpNow() {
        this.stopJump();
        this.jump();
        this.$emit('onJump');
      },
      stopJump() {
        clearInterval(this.jumpIntervalId);
        clearTimeout(this.jumpTimeoutId);
      },
    },
  };
</script>